import AccountManager from "../auth/AccountManager";

export class ApiHandler {
  public async getKey() {
    const token = await AccountManager.getUserToken();
    const response = await fetch(`${process.env.AZURE_FUNCTION_ENDPOOINT}/getUserKey`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Token validation failed");
    }

    return result.key;
  }
}

export default new ApiHandler();